import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ServiceBundler } from './Services/ServiceBundler';
import { AuthProvider, RequireAuth } from './Providers/AuthProvider';
import LoginPage from './Pages/Login/LoginPage';
import InfoPage from './Pages/Info/InfoPage';
import TranslationsPage from './Pages/Languages/Translations/TranslationsPage';
import LanguagePage from './Pages/Languages/LanguagePage';
import ProfilePage from './Pages/Profile/ProfilePage';
import { ConfigProvider, ThemeConfig, theme } from 'antd';
import { AuthService } from './Services/AuthService';
import { WebSocketService } from './Services/WebSocketService';
import { useTranslation } from 'react-i18next';
import DistributionPage from './Pages/SortingSettings/SortingSettingsPage';
import ProductionPage from './Pages/Production/ProductionPage';
import { DetectionSettingsPage } from './Pages/DetectionSettings/DetectionSettingsPage';
import { CameraSettingsPage } from './Pages/CameraSettings/CameraSettingsPage';

export const webSocketService = new WebSocketService();
export const authService = new AuthService();
export const serviceBundler = new ServiceBundler();

export const configThemeLight: ThemeConfig = {
  token: {
    colorPrimary: '#C1D202',
    colorPrimaryText: '#00365f',
    colorPrimaryBg: '#FFFFFF',
  },
};

const configThemeDark: ThemeConfig = {
  token: {
    colorPrimary: '#C1D202',
    colorPrimaryText: '#C1D202',
    colorPrimaryBg: '#141414',
  },
};

export default function App() {
  const { i18n, t } = useTranslation();

  const [currentTheme, setCurrentTheme] = React.useState<'light' | 'dark'>(
    'light',
  );

  React.useEffect(() => {
    setCurrentTheme(serviceBundler.themeService.IsDarkMode ? 'dark' : 'light');

    serviceBundler.themeService.FetchingReadySubject.subscribe((value) => {
      if (value) {
        setCurrentTheme('dark');
      } else {
        setCurrentTheme('light');
      }
    });
  }, [0]);

  return (
    <ConfigProvider
      theme={{
        token:
          currentTheme === 'light'
            ? configThemeLight.token
            : configThemeDark.token,
        algorithm:
          currentTheme === 'light'
            ? theme.defaultAlgorithm
            : theme.darkAlgorithm,
      }}
    >
      <AuthProvider>
        <Routes>
          <Route>
            <Route path="/" element={<DetectionSettingsPage />} />
            <Route path="*" element={<DetectionSettingsPage />} />
            <Route
              path={t('profile').toString().toLocaleLowerCase()}
              element={
                <RequireAuth>
                  <ProfilePage />
                </RequireAuth>
              }
            />
            <Route path="sorting">
              <Route index element={<DetectionSettingsPage />}></Route>
              <Route
                path="camerasettingstab"
                element={
                  // <RequireAuth>
                  <CameraSettingsPage />
                  // </RequireAuth>
                }
              />
              <Route
                path="detectionsettingstab"
                element={
                  // <RequireAuth>
                  <DetectionSettingsPage />
                  // </RequireAuth>
                }
              />
              <Route
                path="sortingsettingstab"
                element={
                  // <RequireAuth>
                  <DistributionPage />
                  // </RequireAuth>
                }
              />
              <Route
                path="productiontab"
                element={
                  // <RequireAuth>
                  <ProductionPage />
                  // </RequireAuth>
                }
              />
            </Route>
            <Route path="languages">
              <Route
                index
                element={
                  <RequireAuth>
                    <LanguagePage />
                  </RequireAuth>
                }
              ></Route>

              <Route
                path=":languageKey"
                element={
                  <RequireAuth>
                    <TranslationsPage />
                  </RequireAuth>
                }
              />
            </Route>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="info"
              element={
                <RequireAuth>
                  <InfoPage />
                </RequireAuth>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </ConfigProvider>
  );
}
